export default "__VITE_ASSET__B_K8DtsG__"